import {Module as name} from "../register";
import {StoreFactory} from '@dealer-group/dealerui';
import store from "../../../store";
import module from "./index";

export default new StoreFactory(store, module, name);
